/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface EmbedsEmbedTokenIdDelete$Params {
  embedTokenId: string;
}

export function embedsEmbedTokenIdDelete(http: HttpClient, rootUrl: string, params: EmbedsEmbedTokenIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, embedsEmbedTokenIdDelete.PATH, 'delete');
  if (params) {
    rb.path('embedTokenId', params.embedTokenId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

embedsEmbedTokenIdDelete.PATH = '/embeds/{embedTokenId}';
